module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_family@2x-42bd58c38f738c434e785f51b348ce36.webp";